import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { AssetClassFormField } from '@/pages/instruments/new-instrument/form-fields/AssetClassFormField'
import { AxeFlagFormField } from '@/pages/instruments/new-instrument/form-fields/AxeFlagFormField'
import { BbgTickerFormField } from '@/pages/instruments/new-instrument/form-fields/BbgTickerFormField'
import { CountryIdFormField } from '@/pages/instruments/new-instrument/form-fields/CountryIdFormField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { DescriptionFormField } from '@/pages/instruments/new-instrument/form-fields/DescriptionFormField'
import { FactorFormField } from '@/pages/instruments/new-instrument/form-fields/FactorFormField'
import { ISINField } from '@/pages/instruments/new-instrument/form-fields/ISINField'
import { IndexTypeFormField } from '@/pages/instruments/new-instrument/form-fields/IndexTypeFormField'
import { IssuerNameFormField } from '@/pages/instruments/new-instrument/form-fields/IssuerNameFormField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { SubFactorFormField } from '@/pages/instruments/new-instrument/form-fields/SubFactorFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { IndexSchemaType } from '@/pages/instruments/new-instrument/schemas/index.schema'

export interface IndexFormFieldsProps {}

export const IndexFormFields: React.FC<IndexFormFieldsProps> = ({}) => {
  const { trigger } = useFormContext<IndexSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-4'}>
      <FormFieldRow>
        <ISINField placeholder={'GBOOO1383545'} />
        <BbgTickerFormField placeholder={'UKC Index'} />
        <CurrencyIdField />
        <IndexTypeFormField />
      </FormFieldRow>

      <FormFieldRow>
        <AssetClassFormField />
        <FactorFormField />
        <SubFactorFormField />
        <AxeFlagFormField />
      </FormFieldRow>

      <FormFieldRow>
        <IssuerNameFormField />
        <CountryIdFormField />
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>

      <DescriptionFormField placeholder={'FTSE 100 Index'} />
    </div>
  )
}
